import BaseWidget from 'components/BaseWidget/BaseWidget';
import DayForecast15Widget from './widgets/Day15ForecastWidget/Day15ForecastWidget';
import DetailedForecastWidget from './widgets/DetailedForecastWidget/DetailedForecastWidget';
import HourlyForecastWidget from './widgets/HourlyForecastWidget/HourlyForecastWidget';
import AirQualityWidget from './widgets/AirQualityWidget/AirQualityWidget';

const ForecastWidget = ({
  widgetType = 'hourlyForecast',
  dimensions,
  isLoading,
  containerSizePx,
}) => {
  return (
    <BaseWidget
      widgetType={widgetType}
      dimensions={dimensions}
      isLoading={isLoading}
      renderers={{
        hourlyForecast: ({ layout, dimensions }) => (
          <HourlyForecastWidget
            layout={layout}
            dimensions={dimensions}
            containerSizePx={containerSizePx}
          />
        ),
        day15Forecast: ({ layout, dimensions }) => (
          <DayForecast15Widget
            layout={layout}
            dimensions={dimensions}
            containerSizePx={containerSizePx}
          />
        ),
        detailedForecast: ({ layout, dimensions }) => (
          <DetailedForecastWidget
            layout={layout}
            dimensions={dimensions}
            containerSizePx={containerSizePx}
          />
        ),
        airQualityForecast: ({ layout, dimensions }) => (
          <AirQualityWidget
            layout={layout}
            dimensions={dimensions}
            containerSizePx={containerSizePx}
            widgetType={widgetType}
          />
        ),
        airQualityObservations: ({ layout, dimensions }) => (
          <AirQualityWidget
            layout={layout}
            dimensions={dimensions}
            containerSizePx={containerSizePx}
            widgetType={widgetType}
          />
        ),
      }}
    />
  );
};

export default ForecastWidget;
